<script>
import { mapGetters } from 'vuex'
import { demo } from '@/mixins/demo'
import IconBase from '@/components/_common/icons/IconBase'
import LoginIcon from '@/components/_common/icons/library/LoginIcon'
import brochureHeader from '@/graphql/query/brochureHeader.graphql'
export default {
  name: 'TheNav',
  components: {
    IconBase,
    LoginIcon
  },
  mixins: [demo],
  computed: {
    ...mapGetters({
      libraryInfo: 'brochure/libraryInfo',
      workingLibrary: 'ovb/workingLibrary',
      // guestUserInfo: 'brochure/guestUserInfo',
      licensePlans: 'brochure/licensePlans',
      pricingTag: 'brochure/pricingTag',
      isHomeProgram: 'brochure/isHomeProgram',
      isBrainRehab: 'brochure/isBrainRehab'
    }),
    libraryOptions () {
      return this.libraryInfo.map(o => {
        return {
          ...o,
          value: o.id,
          selected: (o.id === this.workingLibrary.id),
          label: o.id === 'vision' ? 'Vision Therapy' : `${o.name} Therapy`
        }
      })
    },
    showBernellNav () {
      const partnerCode = (typeof this.pricingTag === 'string') ? this.pricingTag.toLowerCase() : null
      return (partnerCode === 'bernell')
    },
    hideTopNav () {
      return (this.$route.path === '/brain-rehab-home')
    }
  },
  methods: {
    loginWithRedirect () {
      window.location.href = process.env.VUE_APP_LOGIN_URL || 'https://play.ourvisualbrain.com/login'
    }
  },
  created () {
    this.$eventHub.$on('SHOW_FREE_TRIAL', this.onShowFreeTrial)
  },
  apollo: {
    plans: {
      query: brochureHeader,
      loadingKey: 'loading',
      update (data) {
        const licensePlans = {
          vision: data.vision,
          occupational: data.occupational
        }
        this.$store.dispatch('brochure/setLicensePlans', licensePlans)
        this.$store.dispatch('brochure/setLibraryInfo', data.libraryInfo.libraries)
        if (!this.workingLibrary) {
          const defaultLib = data.libraryInfo.libraries.find(o => o.id === 'vision')
          this.$store.dispatch('SET_WORKING_LIBRARY', defaultLib)
        }
      }
    }
  }
}
</script>

<!--<template>-->
<!--  <b-navbar-->
<!--    class="the-nav"-->
<!--    :shadow="false"-->
<!--    :spaced="false"-->
<!--    :fixed-top="true"-->
<!--    :centered="true"-->
<!--    v-if="!hideTopNav"-->
<!--  >-->
<!--    <template #brand>-->
<!--      <template v-if="!isBrainRehab">-->
<!--        <b-navbar-item tag="router-link" :to="{ path: '/' }">-->
<!--          <img-->
<!--            class="ovb-logo"-->
<!--            :src="require('@/assets/promo/img/OVB_logo_gray.svg')"-->
<!--            alt="Our Visual Brain home"-->
<!--          >-->
<!--        </b-navbar-item>-->
<!--      </template>-->
<!--      <template v-else>-->
<!--        <b-navbar-item-->
<!--          tag="router-link"-->
<!--          :to="{ path: '/brain-rehab' }"-->
<!--          class="ovb-logo-container"-->
<!--        >-->
<!--          <img-->
<!--            class="ovb-logo"-->
<!--            :src="require('@/assets/promo/img/OVB_logo_gray.svg')"-->
<!--            alt="Our Visual Brain: Brain Rehab home"-->
<!--          >-->
<!--        </b-navbar-item>-->
<!--      </template>-->
<!--    </template>-->
<!--    <template #start>-->
<!--      <template v-if="!isBrainRehab">-->
<!--        <b-navbar-item-->
<!--          exact-path-->
<!--          v-if="!isBrainRehab"-->
<!--          tag="router-link"-->
<!--          :to="{ name: 'HomeView', params: {stickyNav: true}}"-->
<!--        >-->
<!--          Home-->
<!--        </b-navbar-item>-->
<!--      </template>-->
<!--      <template v-else>-->
<!--        <b-navbar-item-->
<!--          v-if="!isBrainRehab"-->
<!--          tag="router-link"-->
<!--          exact-path-->
<!--          :to="{ name: 'BrainRehab', params: {stickyNav: true}}"-->
<!--        >-->
<!--          Home-->
<!--        </b-navbar-item>-->
<!--      </template>-->
<!--      <template v-if="!isHomeProgram && !isBrainRehab">-->
<!--        <b-navbar-item-->
<!--          tag="router-link"-->
<!--          exact-->
<!--          :to="{ name: 'FeaturesView', params: {stickyNav: true}}"-->
<!--        >-->
<!--          Features-->
<!--        </b-navbar-item>-->
<!--      </template>-->
<!--      <template v-if="!isBrainRehab">-->
<!--        <b-navbar-item-->
<!--          tag="router-link"-->
<!--          :to="{ name: 'ActivitiesView', params: {stickyNav: true}}"-->
<!--        >-->
<!--          Activities-->
<!--        </b-navbar-item>-->
<!--      </template>-->
<!--      <template v-if="showBernellNav">-->
<!--        <b-navbar-item-->
<!--          exact-path-->
<!--          tag="router-link"-->
<!--          :to="{ path: '/partners/bernell', params: {stickyNav: true}}"-->
<!--        >-->
<!--          Bernell Plans-->
<!--        </b-navbar-item>-->
<!--      </template>-->
<!--      <template v-if="!showBernellNav && !isHomeProgram && !isBrainRehab">-->
<!--        <b-navbar-item-->
<!--          exact-path-->
<!--          tag="router-link"-->
<!--          :to="{ name: 'PlansView', params: {stickyNav: true}}"-->
<!--        >-->
<!--          Plans-->
<!--        </b-navbar-item>-->
<!--      </template>-->
<!--      <template v-if="!isBrainRehab">-->
<!--        <b-navbar-item-->
<!--          exact-path-->
<!--          tag="router-link"-->
<!--          :to="{ name: 'AboutView', params: {stickyNav: true}}"-->
<!--        >-->
<!--          About-->
<!--        </b-navbar-item>-->
<!--      </template>-->
<!--      <b-navbar-item-->
<!--        tag="router-link"-->
<!--        :to="{ name: 'ContactView', params: {stickyNav: true}}"-->
<!--      >-->
<!--        Contact-->
<!--      </b-navbar-item>-->
<!--      <template v-if="!isBrainRehab">-->
<!--        <b-navbar-item-->
<!--          tag="router-link"-->
<!--          :to="{ name: 'StoreView', params: {stickyNav: true}}"-->
<!--        >-->
<!--          Bookstore-->
<!--        </b-navbar-item>-->
<!--      </template>-->

<!--    </template>-->

<!--    <template #end>-->
<!--      <b-navbar-item-->
<!--          tag="a"-->
<!--          tabindex="0"-->
<!--          class="button-reset"-->
<!--          href="https://play.ourvisualbrain.com/login"-->
<!--      >-->
<!--        <span>Reset</span>-->
<!--      </b-navbar-item>-->
<!--      <b-navbar-item-->
<!--        tag="a"-->
<!--        tabindex="0"-->
<!--        class="button-login"-->
<!--        @click="loginWithRedirect"-->
<!--      >-->
<!--        <icon-base :width="32" :height="32" aria-hidden="true">-->
<!--          <login-icon />-->
<!--        </icon-base>-->
<!--        <span>Login</span>-->
<!--      </b-navbar-item>-->
<!--    </template>-->
<!--  </b-navbar>-->
<!--</template>-->

<template>
  <b-navbar
      class="the-nav"
      :shadow="false"
      :spaced="false"
      :fixed-top="true"
      :centered="true"
      v-if="!hideTopNav"
  >
    <template #brand>
      <template v-if="!isBrainRehab">
        <b-navbar-item
            tag="router-link"
            :to="{ path: '/' }"
            class="ovb-logo-nav"
        >
          <img
              class="ovb-logo"
              :src="require('@/assets/promo/img/OVB_logo_gray.svg')"
              alt="Our Visual Brain home"
          >
        </b-navbar-item>
      </template>
      <template v-else>
        <b-navbar-item
            tag="router-link"
            :to="{ path: '/brain-rehab' }"
            class="ovb-logo-container"
        >
          <img
              class="ovb-logo"
              :src="require('@/assets/promo/img/OVB_logo_gray.svg')"
              alt="Our Visual Brain: Brain Rehab home"
          >
        </b-navbar-item>
      </template>
    </template>
    <template #start>
      <template v-if="!isBrainRehab">
        <b-navbar-item
            exact-path
            v-if="!isBrainRehab"
            tag="router-link"
            :to="{ name: 'HomeView', params: {stickyNav: true}}"
        >
          <div class="nav-text">Home</div>
        </b-navbar-item>
      </template>
      <template v-else>
        <b-navbar-item
            v-if="!isBrainRehab"
            tag="router-link"
            exact-path
            :to="{ name: 'BrainRehab', params: {stickyNav: true}}"
        >
          <div class="nav-text">Home</div>
        </b-navbar-item>
      </template>
      <template v-if="!isHomeProgram && !isBrainRehab">
        <b-navbar-item
            tag="router-link"
            exact
            :to="{ name: 'FeaturesView', params: {stickyNav: true}}"
        >
          <div class="nav-text">Features</div>
        </b-navbar-item>
      </template>
      <template v-if="!isBrainRehab">
        <b-navbar-item
            tag="router-link"
            :to="{ name: 'ActivitiesView', params: {stickyNav: true}}"
        >
          <div class="nav-text">Activities</div>
        </b-navbar-item>
      </template>
      <template v-if="showBernellNav">
        <b-navbar-item
            exact-path
            tag="router-link"
            :to="{ path: '/partners/bernell', params: {stickyNav: true}}"
        >
          <div class="nav-text">Bernell Plans</div>
        </b-navbar-item>
      </template>
      <template v-if="!showBernellNav && !isHomeProgram && !isBrainRehab">
        <b-navbar-item
            exact-path
            tag="router-link"
            :to="{ name: 'PlansView', params: {stickyNav: true}}"
        >
          <div class="nav-text">Plans</div>
        </b-navbar-item>
      </template>
      <template v-if="!isBrainRehab">
        <b-navbar-item
            exact-path
            tag="router-link"
            :to="{ name: 'AboutView', params: {stickyNav: true}}"
        >
          <div class="nav-text">About</div>
        </b-navbar-item>
      </template>
      <b-navbar-item
          tag="router-link"
          :to="{ name: 'ContactView', params: {stickyNav: true}}"
      >
        <div class="nav-text">Contact</div>
      </b-navbar-item>
      <template v-if="!isBrainRehab">
        <b-navbar-item
            tag="router-link"
            :to="{ name: 'StoreView', params: {stickyNav: true}}"
        >
          <div class="nav-text">Bookstore</div>
        </b-navbar-item>
      </template>

    </template>

    <template #end>
      <b-navbar-item
          tag="a"
          tabindex="0"
          class="button-reset"
          href="https://play.ourvisualbrain.com/login"
      >
        <div class="nav-text">Reset</div>
      </b-navbar-item>
      <b-navbar-item
          tag="a"
          tabindex="0"
          class="button-login"
          @click="loginWithRedirect"
      >
        <icon-base :width="32" :height="32" aria-hidden="true">
          <login-icon />
        </icon-base>
        <div class="nav-text login-text">Login</div>
      </b-navbar-item>
    </template>
  </b-navbar>
</template>

<style lang="scss" scoped>
.ovb-logo {
  display: block;
  min-width: 13rem;
  padding-top: 4px;
  @include tablet {
    min-width: 13rem;
  }
  @include desktop {
    min-width: 13rem;
  }
}
.button-login {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding-top: 0;
  padding-bottom: 0;
  border-radius: 0;
  background-color: transparent;
  border: none;
}
</style>
<style lang="scss">
$transition-time: 1s;
$nav-bottom-border-width: 5px;
.navbar.the-nav {
  background-color: $white;
  border-bottom: 1px solid $gray-lighter;
  z-index: 99;
  min-height: 3.56rem;
  .navbar-brand {
    .navbar-item {
      border-bottom: none;
      &:hover {
        border-bottom: none;
      }
      &.router-link-active {
        border-bottom: none;
      }
    }
  }
  &:not(.is-promo-home) {
    background-color: $white;
    .navbar-item {
      color: $text;
      a {
        color: $text;
        &.router-link-active {
          color: $watermelon;
        }
      }
      &:has(.router-link-active) {
        border-bottom: $nav-bottom-border-width solid $watermelon;
        &:hover {
          border-bottom: $nav-bottom-border-width solid $watermelon;
        }
      }
    }
  }
  .navbar-brand .navbar-item {
    padding-left: 1rem;
  }

  .navbar-item.router-link-active {
    border-bottom: $nav-bottom-border-width solid $watermelon;
    &:hover {
      border-bottom: $nav-bottom-border-width solid $watermelon;
    }
  }
  .navbar-brand .navbar-item.ovb-logo-nav {
    border-bottom: none;
    &:hover {
      border-bottom: none;
    }
  }
  .navbar-item {
    transition: color .3s ease;
    padding-top: $nav-bottom-border-width;
    border-bottom: $nav-bottom-border-width solid transparent;
    &.button-reset {
      color: $gray-lighter;
      &:hover {
        color: $gray-light;
      }
    }
    &:has(.router-link-active) {
      border-bottom: $nav-bottom-border-width solid $watermelon;
      &:hover {
        border-bottom: $nav-bottom-border-width solid $watermelon;
      }
    }
    &:hover {
      color: $watermelon;
      filter: saturate(3);
      background-color: transparent;
      border-bottom: $nav-bottom-border-width solid $white;
    }
    &.login-container {
      padding-right: 1rem;
    }
    .router-link-active {
      color: $watermelon;
    }
    &:focus {
      background-color: $transparent;
      color: $watermelon;
    }
    .nav-text {
      padding-top: 8px;
      line-height: $size-5;
      color: $feldgrau;
      font-size: $size-5;
      &.login-text {
        padding-top: 0;
      }
    }
  }
  .text-outline {
    filter: url('#outline');
  }
  .navbar-burger {
    width: 4rem;
    height: 4rem;
  }
  .navbar-brand, .navbar-tabs {
    min-height: auto;
  }
  .navbar-item img {
    max-height: none;
  }
}
</style>

